import { useState } from "react";
import { IAddProfile, ITimeConfig } from "src/Interfaces/deltaHedgeBackTest";
import PairPositionSearchParamUI from "../OptionDomain/PairPosition/PairPositionSearchParamUI";
import { IPairPositionSearchParams } from "src/Interfaces/optionDomain";
import { Button, TextInput } from "src/Components";
import TimeConfig from "./TimeConfig";
import { addProfile, editProfile } from "src/Requests/deltaHedgeBackTest";
import { toast } from "react-toastify";

interface IProps {
  editValues?: IAddProfile;
  onClose: () => void;
}

const AddProfile = ({ onClose, editValues }: IProps) => {
  const [formValues, setFormValues] = useState(
    editValues || {
      searchParam: {} as IPairPositionSearchParams,
      profileName: "",
      timeConfig: {} as ITimeConfig,
    }
  );

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };
  const timeConfigChangeHandler = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      timeConfig: { ...formValues.timeConfig, [name]: value },
    });
  };

  const pairPositionChangeHandler = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      searchParam: {
        ...formValues.searchParam,
        [name]: value,
      },
    });
  };

  const submitHandler = () => {
    (editValues ? editProfile : addProfile)(formValues).then((resp) => {
      if (!resp.data) toast.error(resp.msg);
      else {
        toast.success(resp.msg);
        onClose();
      }
    });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3">
      <TextInput
        name="profileName"
        value={formValues.profileName}
        label="نام پروفایل"
        onChange={changeHandler}
        extraLabel
        disabled={!!editValues}
      />
      <div className="w-full h-px bg-slate-300" />
      <div className="w-full flex flex-row justify-start items-start gap-5">
        {formValues.searchParam !== null ? (
          <div className="flex flex-col justify-start items-start gap-3">
            <div className="font-bold text-xs">تنظیمات جفت پوزیشن</div>
            <PairPositionSearchParamUI
              searchParam={formValues.searchParam}
              searchParamChangeHandler={pairPositionChangeHandler}
              isDtm
            />
          </div>
        ) : (
          <></>
        )}
        <TimeConfig
          onChange={timeConfigChangeHandler}
          timeConfig={formValues.timeConfig}
        />
      </div>
      <Button
        text={editValues ? "ویرایش" : "ثبت"}
        onClick={submitHandler}
        variant="contained"
      />
    </div>
  );
};

export default AddProfile;
